// Input formats:
// - OCP: { id, name, slug, subcategories: [...] }
// - Strapi: { id, attributes: { title, url, Level1: [...] } }
//
// final output: { categories: [...], categoryLookup: {} }
// - categories: simplified menu items for rendering eg. { id, name, slug, subcategories: [...] }
// - categoryLookup: search for a category by id eg. categoryLookup[id]

const processStrapiMenuData = (strapiData) => {
  const transformStrapiItem = (strapiItem) => {
    const { id, attributes = {} } = strapiItem;
    const { title, url, Level1 = [] } = attributes;

    return {
      id,
      name: title,
      slug: url?.replace("/", "") || "",
      subcategories: Level1.map((level1) => ({
        id: level1.id,
        name: level1.title,
        slug: level1.url?.replace("/", "") || "",
        subcategories:
          level1.Level2?.map((level2) => ({
            id: level2.id,
            name: level2.title,
            slug: level2.url?.replace("/", "") || "",
          })) || [],
      })),
    };
  };

  const categories = strapiData.map(transformStrapiItem);
  const categoryLookup = {};

  // create a lookup for the categories by id
  categories.forEach((category) => {
    categoryLookup[category.id] = category;
  });

  return {
    categories,
    categoryLookup,
  };
};

const processOCPMenuData = (ocpData) => {
  const categoryLookup = {};

  ocpData?.forEach((category) => {
    categoryLookup[category.id] = category;
  });

  return {
    categories: ocpData,
    categoryLookup,
  };
};

export const processMenuData = (menuData) => {
  const isMenuStrapi = process.env.IS_MENU_STRAPI === "true";

  // Handle Strapi response format
  const dataArray = isMenuStrapi && menuData?.data ? menuData.data : menuData;

  if (!dataArray?.length) {
    return { categories: [], categoryLookup: {} };
  }

  return isMenuStrapi
    ? processStrapiMenuData(dataArray)
    : processOCPMenuData(dataArray);
};
